export const PARTNER_CLIENT_FEATURE_KEY = 'partnerClients';
